import React from 'react';
import Pagination from 'react-js-pagination'

const CustomPagination = props => {
	let {handlePaginate} = props

	return (<Pagination {...props} pageRangeDisplayed={5} onChange={handlePaginate}/>)
}

export default CustomPagination;



// WEBPACK FOOTER //
// ./components/zynappse-crud/Table/Pagination.js